import { createPortal } from "react-dom";
import { useRemoteNote } from "./remoteNote.js";

/** The remote's messages, on <body> so they show over the picture too (app.css "Native video"). */
export function RemoteNote() {
  const text = useRemoteNote();
  if (!text) return null;
  return createPortal(
    <div className="remote-note" role="status">
      {text}
    </div>,
    document.body,
  );
}
